import { render } from "./RealtimeInit.vue?vue&type=template&id=5453705c&scoped=true"
import script from "./RealtimeInit.vue?vue&type=script&lang=js"
export * from "./RealtimeInit.vue?vue&type=script&lang=js"

import "./RealtimeInit.vue?vue&type=style&index=0&id=5453705c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5453705c"]])

export default __exports__